import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../../lib/ep';

import ActionLink from '../builder/ActionLink';
import ButtonCollection from '../builder/ButtonCollection';
import RibbonCollection from './RibbonCollection';

const Wrapper = (props) => {
	const overflowed = props?.overflowed ?? true;
	const linked = props?.linked ?? true;
	const maxHeight = props?.maxHeight ?? 'calc(100dvh - 300px)';

	let classes = ['gui_clean_listed_elements'];
	if(linked) classes.push('list_of_linked_items');
	if(overflowed) classes.push('gui_overflowed_auto');
	if(props.classes != undefined) classes.push(props.classes);

	return (
		<ul class={classes.join(" ")} style={(overflowed) ? { height:maxHeight } : null}>
			{props.children}
		</ul>
	)
};

const SimpleListOfItems = ({ items, ...props }) => {
	if(items == undefined) return null;
	
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	if(items.length == 0) {
		return (
			<Wrapper
				maxHeight={props.maxHeight}
				overflowed={props.overflowed}
				linked={props.linked}
				classes={props.classes}
			>
				<li class="gui_remove_pointer_events">{i18n(props?.empty_message ?? "There are no items.")}</li>
			</Wrapper>
		)
	}

	const padded_items = props?.padded_items ?? true;
	const display_created = props?.display_created ?? false;

	return (
		<Wrapper
			maxHeight={props.maxHeight}
			overflowed={props.overflowed}
			linked={props.linked}
			classes={props.classes}
		>
			{items.map((item, i) => {
				const ribbons = item?.ribbons ?? [];
				const actions = item?.actions ?? false;

				const autotranslate = item?.autotranslate ?? true;
				let title = (autotranslate) ? i18n(item.title) : item.title;

				const is_html = item?.is_html ?? false;
				const value = item?.value ?? false;

				let title_classes = ['gui_cutTextOnOverflow', 'title'];
				if(is_html) title_classes.push('is_html');
				if(value !== false) title_classes.push('gui_force_roman');

				let li_classes = [];
				if(!padded_items) li_classes.push('gui_is_not_padded');

				let item_classes = ['item'];
				if(isNotEmpty(item, 'icon')) item_classes.push(`${item.icon} gui_small_icon`);
				return (
					<li key={item?.id ?? `item_${i}`} class={li_classes.join(" ")}>
						<div>
							<div class={item_classes.join(" ")}>
								<div class="gui_pos_rel">
									{(item.title_link != undefined && item.title_link) ? (
										<ActionLink
											_class={{other:title_classes.join(" ")}}
											_href={item.title_link}
											_target={item?.title_link_target ?? '_blank'}
											autotranslate={false}
										>{title}</ActionLink>
									) : (
										typeof title == 'string' ?<span dangerouslySetInnerHTML={{ __html:title }} class={title_classes.join(" ")}/> : <span class={title_classes.join(" ")}>{title}</span>
									)}
								</div>
							</div>

							{(display_created) && (
								<div class="item_created" style={{ flexGrow:'1' }}>
									{EPDateFormat(item.created, 'LL')}
								</div>
							)}

							<div class="gui_flex_end gui_flexbox_auto gui_flex_align_center">
								{(ribbons.length > 0) && (
									<RibbonCollection
										items={ribbons}
									/>
								)}

								{(actions !== false) && (
									<ButtonCollection
										_class={{other:'gui_not_in_start_small'}}
									>{actions}</ButtonCollection>
								)}

								{(value !== false) && (
									<strong
										class="total_value"
										dangerouslySetInnerHTML={{ __html:value }}
									/>
								)}
							</div>
						</div>
					</li>
				)
			})}
		</Wrapper>
	)
};

export default injectIntl(SimpleListOfItems);